import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "payment-requests-details-modal-prices" }
const _hoisted_2 = { class: "payment-requests-details-modal-prices__container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"container__header\"><div class=\"header__title\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z\"></path><path d=\"M12 22V12\"></path><path d=\"m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7\"></path><path d=\"m7.5 4.27 9 5.15\"></path></svg> Суммы </div></div>", 1)
const _hoisted_4 = { class: "container__content" }
const _hoisted_5 = { class: "content__row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "row__label" }, "Базовая сумма:", -1)
const _hoisted_7 = { class: "row__value" }
const _hoisted_8 = {
  key: 0,
  class: "content__additional"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "additional__title" }, "Дополнительные услуги:", -1)
const _hoisted_10 = { class: "record__label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" })
], -1)
const _hoisted_12 = { class: "record__value" }
const _hoisted_13 = { class: "additional__total" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "total__label" }, "Итого доп. услуги", -1)
const _hoisted_15 = { class: "total__value" }
const _hoisted_16 = {
  key: 1,
  class: "content__additional"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "additional__title" }, "Дополнительные услуги:", -1)
const _hoisted_18 = { class: "record__label" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" })
], -1)
const _hoisted_20 = { class: "record__value" }
const _hoisted_21 = { class: "additional__total" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "total__label" }, "Итого доп. услуги", -1)
const _hoisted_23 = { class: "total__value" }
const _hoisted_24 = { class: "content__total" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "total__label" }, "Итого", -1)
const _hoisted_26 = { class: "total__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, [
            (_ctx.waybill)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatPriceToTenge(_ctx.waybill.totalAmount, { withDecimals: true })), 1)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.ftlOrder)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatPriceToTenge(_ctx.ftlOrder.cost_total, { withDecimals: true })), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.waybill && !Array.isArray(_ctx.waybill.totalAdditionalServices))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.waybill.totalAdditionalServices), (service) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "additional__record",
                  key: service
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(service), 1)
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatPriceToTenge(_ctx.waybill.totalAdditionalServices[service], { withDecimals: true })), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatPriceToTenge(_ctx.waybill.additionalServicesTotalAmount, { withDecimals: true }) || _ctx.formatPriceToTenge(0, { withDecimals: true })), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ftlOrder && Array.isArray(_ctx.ftlOrder.shared_additional_service))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ftlOrder.shared_additional_service, (service, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "additional__record",
                  key: `ftl-service-${i}`
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(service.type_name), 1)
                  ]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatPriceToTenge(service.cost_total, { withDecimals: true })), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatPriceToTenge(_ctx.calculateFtlOrderAdditionalServicesCost(), { withDecimals: true })), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formatPriceToTenge(_ctx.calculateFtlOrderTotalCost(), { withDecimals: true })), 1)
        ])
      ])
    ])
  ]))
}